import React from 'react';
import PropTypes from 'prop-types';
import { NoInvoicesFoundCard } from '../components';
import {
  INVOICE_WQ_BULK_ACTIONS,
  REJECTED_CBO_ADMIN_STATUSES,
  REJECTED_STATUSES,
} from '../constants';
import { InvoiceWorkqueue } from './InvoiceWorkqueue';

const RejectedInvoicesDWQ = ({ children }) => (
  <InvoiceWorkqueue
    defaultBulkActions={INVOICE_WQ_BULK_ACTIONS.default}
    cboStatuses={REJECTED_CBO_ADMIN_STATUSES}
    renderNoInvoicesFound={({ isFiltered, resetFilters }) => (
      <NoInvoicesFoundCard isFiltered={isFiltered} status="rejected" resetFilters={resetFilters} />
      )}
    networkLeadStatuses={REJECTED_STATUSES}
    pageName="Rejected"
    path="rejected/"
  >
    {children}
  </InvoiceWorkqueue>
  );

RejectedInvoicesDWQ.propTypes = {
  children: PropTypes.node,
};

RejectedInvoicesDWQ.defaultProps = {
  children: undefined,
};
export default RejectedInvoicesDWQ;
